import * as React from "react";
import { useSelector } from "react-redux";
import { decode } from "html-entities";

export default function SelectedNewsItem(props) {
  const system = useSelector((state) => state.systemReducer);
  const news = props.news;

  return (
    <div className="selected-news-item" onClick={() => props.removeSelectedNewsItem(news)}>
      <div className="selected-news-item-image">
        <img src={`https://${system.subdomain}.companyapp.net${news.field_featured_image}`} />
      </div>
      <div className="selected-news-item-title">{decode(news.title)}</div>
    </div>
  );
}
